import React from 'react';
import { LanguageProvider } from '../contexts/LanguageContext';
import { StarryBackground } from '../components/StarryBackground';
import { SharedNavigation } from '../components/SharedNavigation';
import { Hero } from '../components/Hero';
import { Skills } from '../components/Skills';
import { Education } from '../components/Education';
import { Experience } from '../components/Experience';
import { ProjectsSlider } from '../components/ProjectsSlider';
import { Testimonials } from '../components/Testimonials';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { useSEO } from '../hooks/useSEO';

function IndexContent() {
  useSEO({
    title: 'Abdelrahman Bayoumi - Full Stack Software Engineer',
    description:
      'Full-Stack Software Engineer with 5+ years of experience building high-performance web, desktop, and real-time distributed systems using Angular, Node.js, and .NET.',
    image: 'https://abdelrahmanbayoumi.github.io/og-image.jpg',
    url: 'https://abdelrahmanbayoumi.github.io/',
    type: 'website',
    tags: [
      'full stack engineer',
      'software engineer',
      'Angular',
      'TypeScript',
      'Node.js',
      'NestJS',
      'C#',
      '.NET',
      'SignalR',
      'Redis',
      'Electron',
      'portfolio',
    ],
  });

  return (
    <div className="min-h-screen relative">
      <StarryBackground />
      <SharedNavigation />
      <main>
        <Hero />
        <Skills />
        <ProjectsSlider />
        <Education />
        <Experience />
        {/* <Testimonials /> */}
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

const Index = () => {
  return (
    <LanguageProvider>
      <IndexContent />
    </LanguageProvider>
  );
};

export default Index;
